import { __assign } from 'tslib';
import __vue_component__$a from '../HseHeading/HseHeading.vue.js';
import __vue_component__ from '../HseParagraph/HseParagraph.vue.js';
import __vue_component__$1 from '../HseAttention/HseAttention.vue.js';
import __vue_component__$2 from '../HseBlockquote/HseBlockquote.vue.js';
import __vue_component__$3 from '../HseUl/HseUl.vue.js';
import __vue_component__$4 from '../HseOl/HseOl.vue.js';
import __vue_component__$5 from '../HseLi/HseLi.vue.js';
import __vue_component__$6 from '../HseImg/HseImg.vue.js';
import __vue_component__$7 from '../HseColumns/HseColumns.vue.js';
import __vue_component__$9 from '../HseCollapse/HseCollapse.vue.js';
import __vue_component__$8 from '../HseTable/HseTable.vue.js';

var componentPrefix = 'Hse';
var getComponentNameWithoutPrefix = function (name) {
    return name.slice(componentPrefix.length);
};
var getContentComponentName = function (name) {
    var baseName = getComponentNameWithoutPrefix(name);
    return componentPrefix + "Content" + baseName;
};
var createComponentWithProps = function (component, props) {
    return component.extend({
        name: getContentComponentName(component.name),
        props: props
    });
};
var createComponentWithHasMargin = function (component, additionalProps) {
    return createComponentWithProps(component, __assign(__assign({}, additionalProps), { hasMargin: {
            type: Boolean,
            default: true
        } }));
};
var HseContentHeading = createComponentWithHasMargin(__vue_component__$a, {
    adaptive: {
        type: Boolean,
        default: true
    }
});
var HseContentParagraph = createComponentWithHasMargin(__vue_component__);
var HseContentAttention = createComponentWithHasMargin(__vue_component__$1);
var HseContentBlockquote = createComponentWithHasMargin(__vue_component__$2);
var HseContentUl = createComponentWithHasMargin(__vue_component__$3);
var HseContentOl = createComponentWithHasMargin(__vue_component__$4);
var HseContentLi = __vue_component__$5;
var HseContentImg = createComponentWithHasMargin(__vue_component__$6);
var HseContentColumns = createComponentWithHasMargin(__vue_component__$7);
var HseContentTable = createComponentWithHasMargin(__vue_component__$8);
var HseContentCollapse = createComponentWithProps(__vue_component__$9, {
    hasMargin: {
        type: Boolean,
        default: true
    },
    variant: {
        default: 'content'
    }
});

export { HseContentAttention, HseContentBlockquote, HseContentCollapse, HseContentColumns, HseContentHeading, HseContentImg, HseContentLi, HseContentOl, HseContentParagraph, HseContentTable, HseContentUl };
